<template>
<w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
  <w-settings-content-template slot="activeView" side-width="330px">
    <!-- side -->
    <el-row slot="title" style="padding-right:20px; width:100%;" align="middle">
      <el-row type="flex" justify="space-between" align="space-between" class="title-bar">
        <div style="line-height:28px;">{{treeTitle}}</div>
      </el-row>
    </el-row>
    <div slot="sideContent">
      <w-apm-tree ref="apmTree" style="padding:0px; width:300px;" :defaultSide="false" :isGroupTree="false"
      @changeTreeType="changeTreeType" :forceSelectLeaf="true" :isEditMode="false" :currentTreeType="currentTreeType" @clickNode="clickNode"/>
    </div>
    <!-- content -->
    <div slot="content">
      <component :is="activeView" ref="activeView" :currentNode="currentNode" :tree-type="currentTreeType" @treeReload="treeReload"></component>
    </div>
  </w-settings-content-template>
</w-settings-detail>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WWarningSettingView from './WarningSettingView';
import WApmTree from '../common/components/ApmTree';

const defaultMenu = 'warning';
const treetype = { keyTrs: '키 트랜잭션', application: '어플리케이션', instance: 'WAS 인스턴스' };

export default {
  name: 'WWarningSettings',
  components: {
    WSettingsDetail,
    WSettingsContentTemplate,
    WWarningSettingView,
    WApmTree,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      currentNode: null,
      treeTitle: null,
      isEditMode: false,
      currentTreeType: 'instance',
      activeMenu: defaultMenu,
      activeMenuName: '경보 설정',
      menu: [
        {
          id: 'warning',
          name: '경보 설정',
          active: false,
        },
      ],
      activeView: 'WWarningSettingView',
    };
  },
  watch: {
    currentTreeType: {
      handler() {
        if (!isNil(this.currentTreeType)) {
          this.treeTitle = treetype[this.currentTreeType];
        }
      },
      immediate: true,
    },
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
      const selectedData = find(this.menu, (item) => item.id === menu);
      if (!isNil(selectedData)) {
        this.activeMenuName = selectedData.name;
      }
    },
    startGroupTreeEditMode() {
      // this.$emit('change-edit-mode', true);
      this.isEditMode = !(this.isEditMode);
    },
    changeTreeType() {
      this.isEditMode = false;
    },
    clickNode(node, data) {
      this.currentNode = cloneDeep(node);
      // if (node.type === 'obj' || node.type === 'domain') {
      //   this.settingNodeTitle = `[${data.label}] 경보 설정 목록`;
      // }
    },
    treeReload() {
      this.$refs.apmTree.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/WarningSettings/index.vue